import React from 'react';
export function toArray(candidate) {
    if (candidate === undefined || candidate === false)
        return [];
    return Array.isArray(candidate) ? candidate : [candidate];
}
export function getFieldId(namePath, formName) {
    if (!namePath.length)
        return undefined;
    const mergedId = namePath.join('_');
    return formName ? `${formName}_${mergedId}` : mergedId;
}
/**
 * 遍历 children，通过 visitors 处理 child 的 扩展
 * @param children
 * @param visitors 访问着为一个对象
 * @param visitorsFlag 记号，标记是否已经解析过 visitors 参数
 * @returns
 */
export function traverseChildren(children, visitors = {}, visitorsFlag = false) {
    // 缓存 visitorsFlag 标记
    let flag = visitorsFlag;
    // 生成所有的访问者序列
    let visitorsMapping = {};
    if (visitorsFlag) {
        visitorsMapping = Object.assign({}, visitors);
    }
    else {
        visitorsMapping = Object.keys(visitors).reduce((o, keys) => {
            const allVisitors = Object.assign({}, o);
            keys.split('|').forEach(key => {
                allVisitors[key] = visitors[keys];
            });
            return allVisitors;
        }, {});
        flag = true;
    }
    return React.Children.map(children, child => {
        var _a, _b;
        // 如果 子元素是 字符串 或者 未定义 就不做任何处理
        if ({ string: 1, undefined: 1 }[typeof child]) {
            return child;
        }
        // 取得子组件的名称
        let { type: key } = child;
        if (typeof key !== 'string') {
            key = (key === null || key === void 0 ? void 0 : key.name) || (key === null || key === void 0 ? void 0 : key.displayName);
        }
        let extendProps = {};
        // 继续遍历下一个层子元素
        if ((_a = child === null || child === void 0 ? void 0 : child.props) === null || _a === void 0 ? void 0 : _a.children) {
            extendProps.children = traverseChildren((_b = child === null || child === void 0 ? void 0 : child.props) === null || _b === void 0 ? void 0 : _b.children, visitorsMapping, flag);
        }
        // 合并访问执行体返回的新 props
        if (visitorsMapping[key]) {
            extendProps = Object.assign({}, child === null || child === void 0 ? void 0 : child.props, extendProps, visitorsMapping[key](child) || {});
        }
        return React.cloneElement(child, extendProps);
    });
}
